/** 設定識別ID */
export const SCREEN_ACTION_SETTING_ID = 'recept-screen-action-setting';

/**
 * 受付画面動作設定インターフェース定義
 */
export interface IReceptScreenActionSetting {
  /** 初期カーソル区分 */
  firstFocusDiv: string;
}

/**
 * 初期カーソル区分のenum定義
 */
export const FirstFocusDiv = {
  /** サービス */
  Service: '0',
  /** 組織 */
  Organization: '1',
};

/**
 * 初期カーソル区分の配列情報
 */
export const FirstFocusDivArray: Array<{value: string, text: string}> = [
  { value: '0', text: 'サービス' },
  { value: '1', text: '組織' },
];

/**
 * ベースとなる受付画面動作設定
 */
export const BaseScreenActionSetting: IReceptScreenActionSetting = {
  firstFocusDiv: FirstFocusDiv.Service,
};



// WEBPACK FOOTER //
// ./src/app/feature/recept-screen-action-setting-modal/recept-screen-action-setting-modal.define.ts